var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32012 8.83467C1.71803 8.05267 1.41699 7.66096 1.41699 6.5C1.41699 5.33834 1.71803 4.94804 2.32012 4.16534C3.52216 2.60417 5.53808 0.833336 8.50033 0.833336C11.4626 0.833336 13.4785 2.60417 14.6805 4.16534C15.2826 4.94875 15.5837 5.33904 15.5837 6.5C15.5837 7.66167 15.2826 8.05196 14.6805 8.83467C13.4785 10.3958 11.4626 12.1667 8.50033 12.1667C5.53808 12.1667 3.52216 10.3958 2.32012 8.83467Z",
    stroke: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.5C10.625 7.06359 10.4011 7.60409 10.0026 8.00261C9.60409 8.40112 9.06358 8.625 8.5 8.625C7.93641 8.625 7.39591 8.40112 6.9974 8.00261C6.59888 7.60409 6.375 7.06359 6.375 6.5C6.375 5.93642 6.59888 5.39592 6.9974 4.9974C7.39591 4.59889 7.93641 4.375 8.5 4.375C9.06358 4.375 9.60409 4.59889 10.0026 4.9974C10.4011 5.39592 10.625 5.93642 10.625 6.5Z",
    stroke: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.036265f9508411e2bf902adec19630ba.svg";
export { ForwardRef as ReactComponent };